var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#01cdfb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62561 16.7999L20.774 16.7999C21.2301 16.7999 21.5998 16.4417 21.5998 15.9999C21.5998 15.5581 21.2301 15.1999 20.774 15.1999L9.62561 15.1999C9.16953 15.1999 8.7998 15.5581 8.7998 15.9999C8.7998 16.4417 9.16953 16.7999 9.62561 16.7999ZM8.79992 11.2C8.79992 10.7582 9.15809 10.4 9.59992 10.4L22.7999 10.4C23.2417 10.4 23.5999 10.7582 23.5999 11.2C23.5999 11.6418 23.2417 12 22.7999 12L9.59992 12C9.15809 12 8.79992 11.6418 8.79992 11.2ZM9.00006 20.7999C9.00006 20.3581 9.35823 19.9999 9.80006 19.9999L23.0001 19.9999C23.4419 19.9999 23.8001 20.3581 23.8001 20.7999C23.8001 21.2418 23.4419 21.5999 23.0001 21.5999L9.80006 21.5999C9.35823 21.5999 9.00006 21.2418 9.00006 20.7999Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.6d4d618d.svg";
export { ForwardRef as ReactComponent };